import React from 'react';

const input = 'w-full px-2 py-1.5 border border-slate-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

/**
 * A flag SEBRAE e, só com ela marcada, o responsável pelo projeto.
 *
 * O campo some sem a flag pelo mesmo motivo do cadastro de serviço: campo sem
 * significado na tela é campo que alguém preenche errado.
 */
const SebraeDoLaboratorio = ({ sebrae, responsavel, onSebrae, onResponsavel }) => (
  <div className="sm:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-3 items-start">
    <label className="flex items-start gap-2 px-2 py-1.5 border border-slate-300 rounded cursor-pointer hover:bg-slate-50">
      <input type="checkbox" checked={!!sebrae} className="mt-0.5"
        onChange={(e) => onSebrae(e.target.checked)} />
      <span>
        <span className="block text-sm font-medium text-slate-900">SEBRAE</span>
        <span className="block text-xs text-slate-500">Laboratório vinculado ao programa</span>
      </span>
    </label>
    {sebrae && (
      <div className="sm:col-span-2">
        <label className="block text-xs font-medium text-slate-700 mb-1">Responsável pelo projeto</label>
        <input className={input} value={responsavel || ''}
          onChange={(e) => onResponsavel(e.target.value)} />
        <p className="text-xs text-slate-400 mt-0.5">
          Sai como consultor(a) em todos os relatórios de visita, mesmo quando outro técnico executou.
        </p>
      </div>
    )}
  </div>
);

export default SebraeDoLaboratorio;
